module.exports = __webpack_public_path__ + "img/lianxiwomen.8f12e84e.png";